import { Pipe, PipeTransform } from '@angular/core';

import { I18NextPipe } from 'angular-i18next';

import { ProductSearch } from '@hdms/shared/common-types';

import { SuffixLabel } from './search-products.const';

@Pipe({
  name: 'suffixLabel'
})
export class SuffixLabelPipe implements PipeTransform {
  private static readonly spacerIcon = `<sub class="compressed-bold spacer-icon"></sub>`;

  constructor(private readonly i18next: I18NextPipe) {}

  transform(value: string, product: ProductSearch): string {
    const labelTag = this.getProductSuffixLabels(product)
      .slice(0, 2)
      .reduce(
        (previousValue, currentValue) =>
          `${previousValue}${previousValue ? SuffixLabelPipe.spacerIcon : ''}<sub class="compressed-bold suffix-label ${
            currentValue.isPrimary ? 'text-primary' : ''
          }">${currentValue.label}</sub>`,
        ''
      );
    return labelTag ? `${value}<span class="spacer"></span><span class="suffix-label-group">${labelTag}</span>` : value;
  }

  private getProductSuffixLabels({ isNuron, isNew, isSpecial }: ProductSearch): SuffixLabel[] {
    return (
      [
        [isNuron, 'nuron', true],
        [isNew, 'new', true],
        [isSpecial, 'special', false]
      ] as const
    ).reduce<SuffixLabel[]>(
      (acc, [state, label, isPrimary]) =>
        state ? [...acc, { label: this.i18next.transform(`product.labels.${label}`), isPrimary }] : acc,
      []
    );
  }
}
